import React from 'react';

import CustomButton from "components/CustomButton";

import ActionButtonContentContainer from "./ActionButtonContentContainer";

function GenerateButton({onClick}) {
    return (
        <CustomButton onClick={onClick}>
            <ActionButtonContentContainer>
                <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'
                     strokeLinecap='round' strokeLinejoin='round'>
                    <path d='M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z'/>
                </svg>
                Générer
            </ActionButtonContentContainer>
        </CustomButton>
    );
}

export default GenerateButton;
